import { lazy } from 'react';

export const DialogMapper = {
  'about-dialog': lazy(() => {
    return import('./dialogs/about-dialog/AboutDialog');
  }),
  'bulk-request-pcfs-dialog': lazy(() => {
    return import('./dialogs/bulk-request-pcfs-dialog/BulkRequestPcfsDialog');
  }),
  'check-for-sustainable-alternative-dialog': lazy(() => {
    return import(
      './dialogs/check-for-sustainable-alternative-dialog/CheckForSustainableAlternativeDialog'
    );
  }),
  'export-pcfs-dialog': lazy(() => {
    return import('./dialogs/export-pcfs-dialog/ExportPcfsDialog');
  }),
  'export-product-tasks-dialog': lazy(() => {
    return import('./dialogs/export-product-tasks-dialog/ExportProductTasksDialog');
  }),
  'request-bulk-transfer-components-dialog': lazy(() => {
    return import('./dialogs/bulk-transfer-components-dialog/BulkTransferComponentsDialog');
  }),
  'pcf-info-dialog': lazy(() => {
    return import('./dialogs/pcf-info-dialog/PCFInfoDialog');
  }),
  'request-additional-component-dialog': lazy(() => {
    return import('./dialogs/request-additional-component-dialog/RequestAdditionalComponentDialog');
  }),
  'request-pcf-dialog': lazy(() => {
    return import('./dialogs/request-pcf-dialog/RequestPcfDialog');
  }),
  'reactivate-user-dialog': lazy(() => {
    return import('./dialogs/reactivate-user-dialog/ReactivateUserDialog');
  }),
  'deactivate-user-dialog': lazy(() => {
    return import('./dialogs/deactivate-user-dialog/DeactivateUserDialog');
  }),
  'confirmation-dialog': lazy(() => {
    return import('./dialogs/confirmation-dialog/ConfirmationDialog');
  }),
  'add-user-dialog': lazy(() => {
    return import('./dialogs/add-user-dialog/AddUserDialog');
  }),
  'assign-admin-role-dialog': lazy(() => {
    return import('./dialogs/assign-admin-role-dialog/AssignAdminRoleDialog');
  }),
  'cancel-invitation-dialog': lazy(() => {
    return import('./dialogs/cancel-invitation-dialog/CancelInvitationDialog');
  }),
  'add-product-dialog': lazy(() => {
    return import('./dialogs/add-product-dialog/AddProductDialog');
  }),
  'import-product-pcf-dialog': lazy(() => {
    return import('./dialogs/import-product-pcf-dialog/ImportProductPCFDialog');
  }),
  'add-pcf-dialog': lazy(() => {
    return import('./dialogs/add-pcf-dialog/AddPcfDialog');
  }),
  'share-pcf-dialog': lazy(() => {
    return import('./dialogs/share-pcf-dialog/SharePcfDialog');
  }),
  'add-company-access-dialog': lazy(() => {
    return import('./dialogs/add-company-access-dialog/AddCompanyAccessDialog');
  }),
  'withdraw-permission-dialog': lazy(() => {
    return import('./dialogs/withdraw-permission-dialog/WithdrawPermissionDialog');
  }),
  'delete-permission-dialog': lazy(() => {
    return import('./dialogs/delete-permission-dialog/DeletePermissionDialog');
  }),
  'reactivate-permission-dialog': lazy(() => {
    return import('./dialogs/reactivate-permission-dialog/ReactivatePermissionDialog');
  }),
  'publish-pcf-confirmation-dialog': lazy(() => {
    return import('./dialogs/publish-pcf-confirmation-dialog/PublishPCFConfirmationDialog');
  }),
  // 'enable-two-factor-authentication-diaog': lazy(() => {
  //   return import(
  //     './dialogs/enable-two-factor-authentication-dialog/EnableTwoFactorAuthenticationDialog'
  //   );
  // }),
  'answer-product-task-dialog': lazy(() => {
    return import('./dialogs/answer-product-task-dialog/AnswerProductTaskDialog');
  }),
  'answer-certificate-task-dialog': lazy(() => {
    return import('./dialogs/answer-certificate-task-dialog/AnswerCertificateTaskDialog');
  }),
  'phone-verification-dialog': lazy(() => {
    return import('./dialogs/phone-verification-dialog/PhoneVerificationDialog');
  }),
  'terms-of-use': lazy(() => {
    return import('./dialogs/terms-of-use-dialog/TermsOfUseDialog');
  }),
  'answer-product-task-and-reactivate-dialog': lazy(() => {
    return import(
      './dialogs/answer-product-task-and-reactivate-permission-dialog/AnswerProductTaskAndReactivatePermissionDialog'
    );
  }),
  'pcf-confirmation-dialog': lazy(() => {
    return import('./dialogs/pcf-confirmation-dialog/PcfConfirmationDialog');
  }),
  'select-component-for-calculation-dialog': lazy(() => {
    return import(
      './dialogs/select-component-for-calculation-dialog/SelectComponentForCalculationDialog'
    );
  }),
  'company-identifier-dialog': lazy(() => {
    return import('./dialogs/company-identifier-dialog/CompanyIdentifierDialog');
  }),
  'input-electricity-emissions-info-dialog': lazy(() => {
    return import(
      './dialogs/input-electricity-emissions-info-dialog/InputElectricityEmissionsInfoDialog'
    );
  }),
  'discard-pcf-dialog': lazy(() => {
    return import('./dialogs/discard-pcf-dialog/DiscardPcfDialog');
  }),
  'enter-manual-input-material-dialog': lazy(() => {
    return import('./dialogs/enter-manual-input-material-dialog/EnterManualInputMaterialDialog');
  }),
  'legal-notice-dialog': lazy(() => {
    return import('./dialogs/legal-notice-dialog/LegalNoticeDialog');
  }),
  'manage-sites-dialog': lazy(() => {
    return import('./dialogs/manage-sites-dialog/ManageSitesDialog');
  }),
  'add-certificate-dialog': lazy(() => {
    return import('./dialogs/add-certificate-dialog/AddCertificateDialog');
  }),
  'share-certificate-dialog': lazy(() => {
    return import('./dialogs/share-certificate-dialog/ShareCertificateDialog');
  }),
  'certificates-announcement-dialog': lazy(() => {
    return import('./dialogs/certificates-announcement-dialog/CertificatesAnnouncementDialog');
  }),
  'request-certificate-dialog': lazy(() => {
    return import('./dialogs/request-certificate-dialog/RequestCertificateDialog');
  }),
};

export type DialogType = keyof typeof DialogMapper;
